module.exports = __webpack_public_path__ + "img/福利商城-左banner图.a3990dc8.png";